import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { NumberValueAccessor } from '@angular/forms/src/directives';
import { QueryBuilderConfig, QueryBuilderClassNames, RuleSet } from 'app/plugins/queryBuilder';
import { Entity } from 'app/plugins/queryBuilder/components';


export const RuleBuilderStyles: QueryBuilderClassNames = {
  removeIcon: 'fa fa-minus',
  addIcon: 'fa fa-plus',
  arrowIcon: 'fa fa-chevron-right px-2',
  button: 'btn',
  buttonGroup: 'btn-group',
  rightAlign: 'order-12 ml-auto',
  switchRow: 'd-flex px-2',
  switchGroup: 'd-flex align-items-center',
  switchRadio: 'custom-control-input',
  switchLabel: 'custom-control-label',
  switchControl: 'custom-control custom-radio custom-control-inline',
  row: 'row p-2 m-1',
  rule: 'border',
  ruleSet: 'border',
  invalidRuleSet: 'alert alert-danger',
  emptyWarning: 'text-danger mx-auto',
  operatorControl: 'form-control',
  operatorControlSize: 'col-auto pr-0',
  fieldControl: 'form-control',
  fieldControlSize: 'col-auto pr-0',
  entityControl: 'form-control',
  entityControlSize: 'col-auto pr-0',
  inputControl: 'form-control',
  inputControlSize: 'col-auto'
};

export interface RuleBuilderConfig {
  builderId: number;
  ruleId?: number;
  openDetailRuleId?: number;
  status: string;
  builder: string;
  fields: string;
};

export const EmptyRuleBuilder: QueryBuilderConfigEXT = {
  ruleSet:{ condition: 'and',
            rules: [],
            type: 'RuleSet'
          },
  entities: {
    empty: { name: 'Empty Field' }
  },
  fields: {
    empty: { name: 'None', type: 'string', entity: 'empty', value: 'none' },
  }
};

export interface QueryBuilderConfigEXT extends QueryBuilderConfig
{
  ruleSet: RuleSet,
};



@Injectable()
export class RuleBuilderService {
  private configUrl = 'api/RuleBuilder';

  constructor(private sxHttp: SxHttpService) { }

  getForOutputConfiguration(codSystem: string, outputCode: string): Observable<QueryBuilderConfigEXT> {
    const url = `${this.configUrl}/ForOutputConfiguration/${codSystem}/${outputCode}`;
    return this.sxHttp.get(url)
      .map(response => JSON.parse(response.json().data) as QueryBuilderConfigEXT)
      .catch(this.handleError);
  }

  getForProductReportConfiguration(systemCode: string, businessCode: string,
    productCode: string, productReportCode: string): Observable<QueryBuilderConfigEXT> {
    const url = `${this.configUrl}/ForProductReportConfiguration/${systemCode}/${businessCode}/${productCode}/${productReportCode}`;
    return this.sxHttp.get(url)
      .map(response => JSON.parse(response.json().data) as QueryBuilderConfigEXT)
      .catch(this.handleError);
  }

  getForProductEmailConfiguration(systemCode: string, businessCode: string,
    productCode: string, productEmailCode: string): Observable<QueryBuilderConfigEXT> {
    const url = `${this.configUrl}/ForProductEmailConfiguration/${systemCode}/${businessCode}/${productCode}/${productEmailCode}`;
    return this.sxHttp.get(url)
      .map(response => JSON.parse(response.json().data) as QueryBuilderConfigEXT)
      .catch(this.handleError);
  }

  getForBusinessReportConfiguration(systemCode: string, businessCode: string, reportCode: string): 
    Observable<QueryBuilderConfigEXT> {
    const url = `${this.configUrl}/ForBusinessReportConfiguration/${systemCode}/${businessCode}/${reportCode}`;
    return this.sxHttp.get(url)
      .map(response => JSON.parse(response.json().data) as QueryBuilderConfigEXT)
      .catch(this.handleError);
  }

  getForBusinessReportConfigurationColumn(systemCode: string, businessCode: string, reportCode: string): 
    Observable<QueryBuilderConfigEXT> {
    const url = `${this.configUrl}/ForBusinessReportConfigurationColumn/${systemCode}/${businessCode}/${reportCode}`;
    return this.sxHttp.get(url)
      .map(response => JSON.parse(response.json().data) as QueryBuilderConfigEXT)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Ocurrió un error', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/ruleBuilder.service.ts